import { render, staticRenderFns } from "./feedBackDialog.vue?vue&type=template&id=10063a90&scoped=true"
import script from "./feedBackDialog.vue?vue&type=script&lang=js"
export * from "./feedBackDialog.vue?vue&type=script&lang=js"
import style0 from "./feedBackDialog.vue?vue&type=style&index=0&id=10063a90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10063a90",
  null
  
)

export default component.exports